module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/octopus-star2.185019c6.png";